import { IonIcon } from '@ionic/react';
import DeviceFragment from 'components/core/DeviceFragment';
import ContactMeSection from 'components/portfolio/sections/ContactMeSection';
import FlexBrowser from 'components/portfolio/components/FlexBrowser';
import GitHubAchievmentsSection from 'components/portfolio/sections/GitHubAchievmentsSection';
import HiMVC from 'components/portfolio/components/HiMVC';
import LinkedInSkillsSections from 'components/portfolio/sections/LinkedInSkillsSection';
import RealTimeChess from 'components/portfolio/components/RealTimeChess';
import { codeSlash, hammer, logoGithub } from 'ionicons/icons';
import { HStack, VStack } from 'reaction';
import brand from 'assets/branding/VirajShahLogoHorizontal.png';
import './Portfolio.css';

export default function Portfolio() {
    return (
        <VStack className='portfolio' justify='start'>
            <Navigation />
            <Hero />

            <GitHubAchievmentsSection />
            <LinkedInSkillsSections />
            <FlexBrowser />
            <HiMVC />
            <RealTimeChess />

            <ContactMeSection />
        </VStack>
    );
}

function Navigation() {
    return (
        <HStack className='navbar' justify='between'>
            <img src={brand} alt='Viraj Shah Brand' height='100%' />

            <nav className='portfolio-navigation'>
                <a href='#github-achievments'>
                    <IonIcon icon={logoGithub} />
                </a>
                <a href='#skills'>
                    <IonIcon icon={hammer} />
                </a>
                <a href='#projects'>
                    <IonIcon icon={codeSlash} />
                </a>
            </nav>
        </HStack>
    );
}

function Hero() {
    function HeroContent() {
        return (
            <>
                <h1 className='hero-title'>I live to code. So there's a lot I want to show you.</h1>

                <p className='hero-paragraph'>
                    Check out my GitHub projects and badges. How about my LinkedIn Skills
                    Assessments. My resume? My websites? My blog? I compiled everything I'm proud of
                    and put them here.
                </p>
            </>
        );
    }

    return (
        <>
            <DeviceFragment type={[null, 'tablet']}>
                <VStack className='hero mobile' align='start' justify='start'>
                    <HeroContent />
                </VStack>
            </DeviceFragment>

            <DeviceFragment type={['desktop', null]}>
                <VStack className='hero' align='start' justify='start'>
                    <HeroContent />
                </VStack>
            </DeviceFragment>
        </>
    );
}
